import { symbolsName } from "sg-consts";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import GraphicsManager from "slotworks/graphics/graphics-manager";
import Layers from "slotworks/graphics/layers/layers";
import Point from "slotworks/utils/geom/point";

export default class SGSymbolComponent extends SymbolComponent {

    public static WILD_SYMBOLD_TEXTURE_PREFIX: string = "wild_";

    constructor(gridPosition: Point, matrixLayer: Layers, animationLayer: Layers) {
        super(gridPosition, matrixLayer, animationLayer);
    }

    protected createStaticSprite(id: string): PIXI.Sprite {
        const texture = (id === symbolsName.WILD) ? GraphicsManager.getTexture(this.getWildTextureId()) : GraphicsManager.getTexture(id);
        return new PIXI.Sprite(texture);
    }

    private getWildTextureId(): string {
        return SGSymbolComponent.WILD_SYMBOLD_TEXTURE_PREFIX + Math.max(1, Math.min(this.gridPosition.x - 1, 3));
    }

}
